/**
 * ForecastPlPrint — page « Compte de résultat » du Prévisionnel.
 * Réutilise la TABLE RÉELLE de l'écran (PlTable, mode prévisionnel = non
 * actualsOnly) : 12 mois (réel + forecast, sous-en-tête Actual/Forecast) + Total
 * cumulé + Total FY. Vue standardisée : Chiffre d'affaires + coût des ventes
 * ouverts, reste replié. Unité = hub Prévisionnel. Lecture seule.
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPlView } from '../../api/financials_pl';
import { PlTable } from '../ProfitLossPage';
import { usePersistentValue } from '../../hooks/usePersistentState';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

const noop = () => {};
const EMPTY = new Set();
const OPEN_SECS = new Set(['revenue', 'cogs']);

export default function ForecastPlPrint({ activeTenant, year, editedAt, onDataReady }) {
  const { t } = useTranslation();
  const tenantId = activeTenant?.id;
  const [view, setView] = useState(null);
  const [unit] = usePersistentValue(`prev_unit_${tenantId}`, 'kchf');
  const thousands = unit !== 'chf';

  useEffect(() => {
    let alive = true;
    if (!tenantId) return undefined;
    getPlView(tenantId, year)
      .then((r) => { if (alive) setView(r.data || null); })
      .catch(() => {})
      .finally(() => { if (onDataReady) onDataReady('forecast-pl'); });
    return () => { alive = false; };
  }, [tenantId, year]); // eslint-disable-line

  if (!view) return <div className="ppl-print__section"><p>Chargement…</p></div>;

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={t('phrases:p_6ac06e4cde')} title={t('phrases:p_8e0f28455c')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <PlTable
        view={view} prevView={null} thousands={thousands}
        brushMode={false} activeLine={null} onPickLine={noop} onPaint={noop}
        expanded={EMPTY} onToggleLine={noop} expandedSecs={OPEN_SECS} onToggleSection={noop}
        readOnly onAssign={noop} editMode={false} onEditValue={noop} onEditForecast={noop}
        onFillCs={noop} onFillTax={noop} fcMode={false} canForecast={false}
        sectionFilter={null} subtotalFilter={null} onSetMethod={noop} addToast={noop}
      />
    </section>
  );
}
